import {triggerEvent} from '../base/utils';
import Popup from './popup';

class VideoPopup {
    constructor($banner) {
        this.$banner = $banner;
        this.$trigger = $banner.querySelector('.js-video-trigger');
        this.$popup = $banner.querySelector('.popup-overlay');

        this.events();
    }

    events() {
        this.$trigger.addEventListener('click', e => {
            e.preventDefault();
            this.openPopup();
        });

        this.$popup.querySelector('.popup-close').addEventListener('click', this.closePopup.bind(this));
        this.$popup.addEventListener('click', this.handleOverlayClick.bind(this));
        document.body.addEventListener('keydown', this.handleEsc.bind(this));
    }

    openPopup() {
        Popup.open(this.$popup);
        this.$popup.querySelector('.video-play').click();
    }

    closePopup() {
        triggerEvent(document.body, 'video-pause');
        Popup.close(this.$popup);
    }

    handleEsc(e) {
        let isEsc;

        if ("key" in e) {
            isEsc = (e.key === "Escape" || e.key === "Esc");
        } else {
            isEsc = (e.keyCode === 27);
        }

        if (isEsc) {
            this.closePopup();
        }
    }

    handleOverlayClick(e) {
        if (
            !e.target.closest('.video') &&
            !e.target.classList.contains('popup-close')
        ) {
            this.closePopup();
        }
    }
}

export default VideoPopup;
